// 検索条件を共有するためのState (URLへの反映は別途)
import type { CircleSearchParam, CircleSearchParamForState } from "~/types/entity/cWebCatalog";

const getDefaultValue = (): CircleSearchParamForState => ({
  // event_id: 0,
  keyword: undefined,
  day: undefined,
  blocks: undefined,
  genres: undefined,
  wcid: undefined,
  prev: undefined,
  // sort: sortDefaultValue,
  // count: 100,
  page: 1
});

export const useCircleSearchState = () => {
  const state = useState<CircleSearchParamForState>("circleSearchParam", getDefaultValue);

  const reset = () => {
    state.value = getDefaultValue();
  };

  const setPage = (page: number) => {
    state.value = {
      ...state.value,
      page: page
    };
  };

  const setGenre = (genres: string | undefined) => {
    state.value = {
      ...state.value,
      genres: genres
    };
  };

  const setDay = (day: number | undefined) => {
    state.value = {
      ...state.value,
      day: day
    };
  };

  /**
   * genres, blocks が配列とカンマの変換を要する。その他既定値の埋め込み
   * @param event_id
   * @returns
   */
  const getCircleSearchParam = (): CircleSearchParam => ({
    // event_id: event_id,
    keyword: state.value.keyword,
    genres: state.value.genres ? state.value.genres.split(",") : undefined,
    area: state.value.area ?? "",
    blocks: state.value.blocks ? state.value.blocks.split(",") : undefined,
    day: state.value.day,
    canUseElectronicPayment: state.value.canUseElectronicPayment,
    sort: state.value.sort,
    page: state.value.page ?? 1
  });

  const setCircleSearchParam = (v: CircleSearchParam): Readonly<CircleSearchParam> => {
    state.value = {
      keyword: v.keyword,
      genres: v.genres?.join(","),
      area: v.area,
      blocks: v.blocks?.join(","),
      day: v.day,
      canUseElectronicPayment: v.canUseElectronicPayment,
      sort: v.sort,
      page: v.page
    };
    return getCircleSearchParam();
  };

  // アプリケーション内でグローバルな state の操作は影響範囲が大きいので 手軽に使える値の操作として公開せず
  // 関数呼び出しとして見せる
  return {
    /**
     * パラメータとして取得する
     */
    get: getCircleSearchParam,
    /**
     * パラメータを更新する
     * @param v
     * @returns
     */
    set: setCircleSearchParam,
    // /**
    //  * watchで利用するための値を返す。この値に対して直接操作してはいけない
    //  * @returns state 自体を返す
    //  */
    // getForWatch: (): Ref<CircleSearchParam> => state,
    /**
     * 初期状態に戻す
     * ただし一部の値を維持することがある (例えば event_id)
     *
     * 1関数内で 他の値設定を続いて呼び出した場合 画面の再描画されないことが期待できる
     */
    reset,
    /**
     * ページを設定する
     */
    setPage,
    /**
     * ジャンルを設定する
     */
    setGenre,
    setDay
  };
};
